// import { HAMBURGER } from "./bundle/_consts";
// import { FULL_SCREEN_OVERLAY } from "./bundle/_consts";
// import { TO_TOP } from "./bundle/_consts";

// import { floatingMenuDisplayControl, toTop } from "./bundle/_floatingMenu";
// import { linkWithinPageControl } from "./bundle/_scrollToAnchor";
// import { drawerDisplayControl } from "./bundle/_drawerControl";

// フローティングメニュー関係のイベントを登録する
// document.addEventListener('DOMContentLoaded', floatingMenuDisplayControl, false);
// window.addEventListener('scroll', floatingMenuDisplayControl, false);
// if (TO_TOP) {
//   TO_TOP.addEventListener('click', toTop, false);
// }

// ハンバーガーボタンのクリックイベントを登録する
// if (HAMBURGER) {
//   HAMBURGER.addEventListener('click', drawerDisplayControl, false);
// }

// オーバーレイがクリックされたときのイベントを登録する
// if (FULL_SCREEN_OVERLAY) {
//   FULL_SCREEN_OVERLAY.addEventListener('click', drawerDisplayControl, false);
// }

// ページ内リンクをスムーススクロールさせるためクリックイベントを登録する
// document.addEventListener('DOMContentLoaded', linkWithinPageControl, false);

class Slider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js_slider');
    this.buttonPrev = this.querySelector('.js_sliderNavigationPrev');
    this.buttonNext = this.querySelector('.js_sliderNavigationNext');
    this.pagination = this.querySelector('.js_sliderPagination');
    this.sliderInstance = null; // Swiper instance placeholder
  }

  initializeSlider(sliderOptions) {
    if (!this.slider) {
      console.error('Slider element not found.');
      return;
    }

    // Ensure existing Swiper instance is destroyed before reinitializing
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
    }

    // Initialize Swiper with provided settings
    this.sliderInstance = new Swiper(this.slider, {
      ...sliderOptions,
      ...(this.buttonPrev && this.buttonNext
        ? {
            navigation: {
              nextEl: this.buttonNext,
              prevEl: this.buttonPrev,
            },
          }
        : {}),
      ...(this.pagination
        ? {
            pagination: {
              el: this.pagination,
              clickable: true,
            },
          }
        : {}),
    });
  }
}

customElements.define('gd-slider', Slider);

class Slideshow extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js_slider');
    this.buttonPrev = this.querySelector('.js_sliderNavigationPrev');
    this.buttonNext = this.querySelector('.js_sliderNavigationNext');
    this.pagination = this.querySelector('.js_sliderPagination');
    this.sliderInstance = null; // Swiper instance placeholder
  }

  initializeSlider() {
    // Ensure existing Swiper instance is destroyed before reinitializing
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
    }

    // Initialize Swiper with provided settings
    this.sliderInstance = new Swiper(this.slider, {
      spaceBetween: 0,
      loop: true,
      speed: 1000,

      on: {
        afterInit: () => {
          updateProgress(0);
        },
        realIndexChange: (swiper) => {
          updateProgress(swiper.realIndex);
        },
      }
    });
  }
}

customElements.define('gd-slideshow', Slideshow);

class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.mainWrapper = this.querySelector('#js_productGalleryMainWrapper');
    this.main = this.querySelector('#js_productGalleryMain');
    this.thumb = this.querySelector('#js_productGalleryThumb');
    this.initializeSlider();
  }

  initializeSlider() {
    const thumbSlider = new Swiper(this.thumb, {
      slidesPerView: 6,
      spaceBetween: 8,
      loop: false,
      speed: 1000,
      breakpoints: {
        1000: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      },
    })

    const mainSlider = new Swiper(this.main, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      speed: 1000,
      navigation: {
        prevEl: this.mainWrapper.querySelector('.js_sliderNavigationPrev'),
        nextEl: this.mainWrapper.querySelector('.js_sliderNavigationNext'),
      },
      thumbs: {
        swiper: thumbSlider,
      },
    })
  }
}

customElements.define('gd-product-gallery', ProductGallery);

{
  const tabs = document.querySelectorAll('.js_sellOnTab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(tab => {
        tab.classList.remove('is_active');
      });
      tab.classList.add('is_active');

      const sliders = document.querySelectorAll('.js_sellOnContent');
      sliders.forEach(slider => {
        slider.classList.remove('is_active');
      });
      const targetId = tab.dataset.targetId;
      const target = document.getElementById(targetId)
      target.classList.add('is_active');
    });
  });
}